const nav = {
    'nav.dashboard': 'Dashboard',
    'nav.profiles': 'Profiles',

    'nav.profile': 'My profile',

    'nav.ghost.return_to_reseller': 'Return to reseller',
    'nav.ghost.return_to_admin': 'Return to admin',

    'nav.footer.about': 'About Speedcon B.V.',
    'nav.footer.conditions': 'Conditions',
    'nav.footer.help': 'Help',
    'nav.footer.contact': 'Contact',
    'nav.footer.logged_in': 'You are now logged in as',
};

export default nav;
